export namespace UserConstants {
  export enum DocumentType {
    CPF = "CPF",
  }

  export enum AdditionalDocumentType {
    IDENTITY_CARD = "IDENTITY_CARD",
    DRIVER_LICENSE = "DRIVER_LICENSE",
  }

  export const DocumentTypeOptions = [{ value: DocumentType.CPF, label: "CPF" }];

  export const AdditionalDocumentTypeOptions = [
    { value: AdditionalDocumentType.IDENTITY_CARD, label: "RG" },
    { value: AdditionalDocumentType.DRIVER_LICENSE, label: "CNH" },
  ];

  export enum Type {
    SELLER = "SELLER",
    BUYER = "BUYER",
    COLLABORATOR = "COLLABORATOR",
    KIRVANO = "KIRVANO",
  }

  export enum BiometryStatus {
    PENDING = "PENDING",
    CAPTURE = "CAPTURE",
    STORED_DOCUMENTS = "STORED_DOCUMENTS",
    SENT_DOCUMENTS = "SENT_DOCUMENTS",
    MEDIATION = "MEDIATION",
    APPROVED = "APPROVED",
    REFUSED = "REFUSED",
    ERROR = "ERROR",
  }

  export enum BlockCheckout {
    ACTIVE = "ACTIVE",
    BLOCKED = "BLOCKED",
    INACTIVE = "INACTIVE",
  }

  export enum ContactType {
    EMAIL = "EMAIL",
    PHONE = "PHONE",
  }

  export enum ContactTypes {
    EMAIL = "EMAIL",
    WHATSAPP = "WHATSAPP",
    SMS = "SMS",
    PHONE = "PHONE",
  }

  export const ContactTypesText = {
    EMAIL: "E-mail",
    SMS: "SMS",
    WHATSAPP: "Whatsapp",
    PHONE: "Telefone",
  };

  export enum VerificationStatus {
    PENDING_DATA = "PENDING_DATA",
    VERIFIED_DATA = "VERIFIED_DATA",
    BIOMETRY_PENDING = "BIOMETRY_PENDING",
    BIOMETRY_UNDER_ANALYSIS = "BIOMETRY_UNDER_ANALYSIS",
    BIOMETRY_REFUSED = "BIOMETRY_REFUSED",
    BIOMETRY_APPROVED = "BIOMETRY_APPROVED",
  }
}

export interface UserType {
  uuid: string;
  name: string;
  email: string;
  emailVerifiedAt: Date | null;
  documentType: UserConstants.DocumentType | null;
  document: string | null;
  additionalDocumentType: UserConstants.AdditionalDocumentType | null;
  additionalDocument: string | null;
  additionalDocumentIssueDate: string | null;
  photo: string | null;
  birthDate: string | null;
  phoneNumber: string | null;
  phoneNumberVerifiedAt: Date | null;
  address: AddressPropsType | null;
  type: UserConstants.Type;
  allowAppNotification: boolean;
  canInvite: boolean;
  inviteComission: number | null;
  blockCheckout: UserConstants.BlockCheckout;
  verificationStatus: UserConstants.VerificationStatus;
  biometryStatus: UserConstants.BiometryStatus;
  biometryLeadId?: string | null;
  isUpdated: boolean;
  isDocumentUpdated: boolean;
  companyUuid?: string;
  permissions: string[];
  roles?: string[];
  requestUpdateContact?: UserRequestUpdateContactType[];
  userUtms: AuthenticatedUserUtms | null;
  isFormCompleted?: boolean;
  offerValueLimit: number;
  hasProducts: boolean;
}

export interface UserRequestUpdateContactType {
  type: UserConstants.ContactType;
  expireDate: Date;
}

export interface AuthenticatedUserUtms {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
}

type AddressPropsType = {
  country: "";
  zipCode: "";
  street: "";
  number: "";
  complement: "";
  district: "";
  city: "";
  state: "";
};

export interface VerifyInvitationResponseType {
  status: string;
}

export interface ResetPasswordType {
  token: string;
  password: string;
  passwordConfirmation: string;
}

export interface CreatePasswordType {
  token: string;
  password: string;
  passwordConfirmation: string;
}

export interface RecoverPasswordType {
  email: string;
}

export interface RecoverPasswordResponseType {
  email: string;
}

export interface VerifyInvitationType {
  inviteCode: string;
}
